import { motion } from "framer-motion";
import { MapPin, CalendarDays, Clock3, Ticket, Cat } from "lucide-react";

const Row = ({ icon: Icon, label, value, testid }) => (
  <div className="flex items-start gap-4 py-5 border-b border-white/10" data-testid={testid}>
    <Icon size={18} className="text-acid shrink-0 mt-1" strokeWidth={1.5} />
    <div>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}</p>
      <p className="font-display font-semibold text-lg sm:text-xl text-foreground mt-1">{value}</p>
    </div>
  </div>
);

export const EventDetails = ({ event }) => {
  return (
    <section className="relative bg-black py-24 sm:py-32 px-4 sm:px-6 overflow-hidden" data-testid="event-details-section">
      <div className="absolute inset-0 tile-grid opacity-[0.1]" />
      <div className="relative max-w-3xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-blood mb-4 flex items-center gap-2"
        >
          <Cat size={14} /> The Haunting — Details
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-extrabold uppercase text-3xl sm:text-5xl tracking-tight mb-10"
        >
          {event.city}, Are You Ready?
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="border-t border-white/10"
        >
          <Row icon={MapPin} label="Venue" value={event.venueName} testid="venue-info-card" />
          <Row icon={CalendarDays} label="Date" value={event.dateLabel} testid="event-date-row" />
          <Row icon={Clock3} label="Time" value={event.timeLabel} testid="event-time-row" />
          <Row icon={Ticket} label="Tickets" value={`${event.priceLabel} · ${event.ticketPartner}`} testid="event-ticket-row" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-12"
        >
          <a
            href={event.ticketUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="details-get-tickets-btn"
            className="inline-flex items-center gap-3 bg-acid text-black font-display font-extrabold uppercase tracking-wide text-sm sm:text-base px-8 py-4 hover:bg-white transition-colors duration-300"
          >
            Get Tickets — {event.priceLabel}
          </a>
          <p className="mt-4 font-mono text-[11px] text-zinc-500 uppercase tracking-wider">
            {event.presenter} · Come dressed for Halloween
          </p>
        </motion.div>
      </div>
    </section>
  );
};
